import { defaultFlowFlags } from './state';

/* eslint-disable no-param-reassign */
export default {
    /**
     * @override
     */
    SET_CONFIGVARS(state, configVars) {
        state.configVars = configVars;
    },
    SET_FLOW_FLAGS(state, flowFlags) {
      state.flowFlags = {
        ...state.flowFlags,
        ...flowFlags
      };
    },
    RESET_FLOW_FLAGS(state) {
      state.flowFlags = defaultFlowFlags();
    },
};
